<template>
      <OptionsForm
        @submit="onSubmit(value_)"
        class="p-3"
        :value="value_"
        :fields="fields"
        :errors.sync="errors"
      >
        <div class="d-flex justify-content-end align-items-center">
          <b-spinner small
            class="mr-2"
            v-show="busy"
          />
          <button type="button"
            class="btn btn-secondary mr-2"
            @click="$emit('cancel')"
            :disabled="busy"
          >Cancel</button>
          <button type="submit"
            class="btn btn-primary"
            :disabled="busy"
          >Save</button>
        </div>
      </OptionsForm>
</template>

<script>
import OptionsForm from '@/components/OptionsForm.vue'
import { onFormError, extraKeys } from '@/components/OptionsFormFields.vue'
import { http } from '@/services/http.js'
import { cloneDeep } from '@/utils/clone.js'

export default {
  name: 'MediaEdit',
  components: {
    OptionsForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      value_: cloneDeep(this.value),
      busy: false,
      errors: {},
      fields: {
        "id": {
          "type": "string",
          "required": true,
          "read_only": true,
          "label": "ID",
          "props": {
            "class": "form-control-plaintext text-reset bg-transparent"
          }
        },
        "image": {
          "type": "image upload",
          "label": 'Image',
        },
        "title": {
          "type": "string",
          "required": true,
          "label": "Title"
        },
        "caption": {
          "type": "string",
          "label": "Description"
        },
        "keywords": {
          "type": "list",
          "required": true,
          "label": "Keywords",
        },
        "location": {
          "type": "location",
          "label": "Location",
        },
      },
    }
  },
  watch: {
    value(val) {
      this.value_ = cloneDeep(val)
    },
  },
  methods: {
    async onSubmit(item) {
      this.busy = true
      const id = item.id
      const requestData = toFormData(item)
      const request = (id)
        ? http.patch(`/api/images/${id}/`, requestData)
        : http.post(`/api/images/`, requestData)
      const response = await request
        .catch(err => {
          if (err.response) {
            this.errors = err.response.data
          }
          onFormError(err, this.errors, extraKeys(this.fields, this.errors))
          throw err
        })
        .finally(() => this.busy = false)
      this.$emit('success', response.data, item)
    },
  },
}

export function toFormData(item) {
  const formData = new FormData()
  formData.set('data', JSON.stringify(item))
  if (item.image instanceof File) {
    formData.set('image', item.image, item.image.name)
  }
  return formData
}
</script>
